module.exports = __webpack_public_path__ + "assets/img/mask-five.c1cfd949.png";